module.exports = __webpack_public_path__ + "static/media/step-1-tissue.3ebf26ce.svg";